/**
 * Groupings Service
 * Frontend service for groupings configuration API calls
 */

import { apiClient, APIResponse } from './client';
import { GroupingsConfig } from '../../types/groupings';

class GroupingsService {
  /**
   * Get groupings configuration for a client.
   * Returns null if not configured (404).
   */
  async getGroupings(clientId: string): Promise<GroupingsConfig | null> {
    try {
      const response: APIResponse<GroupingsConfig> = await apiClient.get(
        `/api/v1/groupings/${clientId}/config`
      );
      return response.data;
    } catch (error: any) {
      if (error.message?.includes('404')) {
        return null;
      }
      throw error;
    }
  }

  /**
   * Save groupings configuration for a client.
   * Requires manage_groupings permission.
   */
  async saveGroupings(clientId: string, config: GroupingsConfig): Promise<GroupingsConfig> {
    const response: APIResponse<GroupingsConfig> = await apiClient.put(
      `/api/v1/groupings/${clientId}/config`,
      config
    );
    return response.data;
  }
}

export const groupingsService = new GroupingsService();
